import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { Login } from '../screens/Login';
import { useContext, useEffect } from 'react';
import { GlobalUtilContext } from './contexts';
import { Telemetry } from '../screens/Telemetry';
import PlaceholderPage from '../screens/PlaceholderPage';

export const Router = () => {
  const { isLoggedIn } = useContext(GlobalUtilContext);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const pathPieces = pathname?.split('/');
    const isInsideService = pathPieces?.[1]?.length > 0;

    if (isLoggedIn && !isInsideService && pathname) {
      const localName = localStorage.getItem('service');
      if (localName) {
        navigate(localName, { replace: true });
      }
    }
  }, [pathname, isLoggedIn, navigate]);

  return (
    <Routes>
      <Route path=":serviceName">
        {isLoggedIn && <Route element={<Telemetry />} path="" />}
        {!isLoggedIn && <Route element={<Login />} index />}
        {!isLoggedIn && <Route element={<Login />} />}
      </Route>
      {isLoggedIn && <Route element={<Telemetry />} path="" />}
      {!isLoggedIn && <Route element={<PlaceholderPage />} path="*" />}
    </Routes>
  );
};

export default Router;
